import { render } from "./DatabaseEdit.vue?vue&type=template&id=30c549e0"
import script from "./DatabaseEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./DatabaseEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Database/DatabaseEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30c549e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30c549e0', __exports__)) {
    api.reload('30c549e0', __exports__)
  }
  
  module.hot.accept("./DatabaseEdit.vue?vue&type=template&id=30c549e0", () => {
    api.rerender('30c549e0', render)
  })

}


export default __exports__